import React from "react";
import './Associates.css';

const Associates = () => {
  return (
    <div><p>hello</p></div>
  )
}

export default Associates;